const SWAGGER_CONSTANTS = {
  username: '******',
  password: '******',
};
export default SWAGGER_CONSTANTS;
